import React from 'react'
import { TNAppDownloadImage } from '../TNAppDownloadImage/TNAppDownloadImage'
import { TNAppDownloadContent } from '../TNAppDownloadContent/TNAppDownloadContent'
import {
    StyledTNAppDownloadPage,
    StyledTNAppDownloadPageWrapper,
} from './TNAppDownloadPage.styled'

export function TNAppDownloadPage() {
    return (
        <StyledTNAppDownloadPageWrapper>
            <StyledTNAppDownloadPage>
                <TNAppDownloadContent />
                <TNAppDownloadImage />
            </StyledTNAppDownloadPage>
        </StyledTNAppDownloadPageWrapper>
    )
}
